.fp-vertical-spacing(data-test='notFound')
  .fp-vertical-spacing--line.-align-center
    span.fp-text(data-test='title') {{ t(notFoundUi.titleKey) }}
  .fp-vertical-spacing--line.-justify-center
    FairplayerButtonVue(icon='home' :text='t(notFoundUi.buttonKey)' @click='goTo')
